import { Redirect, useParams } from 'react-router-dom';
import { Card, Col } from 'reactstrap';
import { TextsProvider } from './hooks/textsContext';
import HeaderInfo from './parts/Header/HeaderInfo';
import GradingStructureFormLoader from './parts/Loaders/GradingStructureFormLoader';
import GradingStructureInfoLoader from './parts/Loaders/GradingStructureInfoLoader';
import InitUpdateStructureTypeForm from './parts/UpdateStructureTypeForm';
import { UpdateStructureTypeForm } from './parts/UpdateStructureTypeForm/UpdateStructureTypeForm';
import useQuery from '../../../hooks/useQuery';
import { PathsLayouts } from '../../../config/routes';

function GradingStructureEdit() {
  const { gradesAcademicId } = useParams<{ gradesAcademicId: string }>();
  const query = useQuery();
  const deliveryMode = query.get('deliveryMode');

  if (!deliveryMode) {
    return (
      <Redirect to={`${PathsLayouts.configurations}/?tab=gradingStructure`} />
    );
  }

  return (
    <Col>
      <Card className="p-4">
        <TextsProvider>
          <GradingStructureFormLoader>
            <GradingStructureInfoLoader
              gradesAcademicId={+gradesAcademicId}
              deliveryMode={deliveryMode}
            >
              <InitUpdateStructureTypeForm>
                <header className="mb-3">
                  <HeaderInfo />
                </header>
                <UpdateStructureTypeForm />
              </InitUpdateStructureTypeForm>
            </GradingStructureInfoLoader>
          </GradingStructureFormLoader>
        </TextsProvider>
      </Card>
    </Col>
  );
}
export default GradingStructureEdit;
